<template>
  <VList
    v-bind="{ ...$props, ...$attrs }"
    dense
    class="w-list"
  >
    <slot />
    <VListItemGroup>
      <slot name="content" />
    </VListItemGroup>
  </VList>
</template>

<script>
import { VList, VListItemGroup } from 'vuetify/lib';

/**
 * @component WorkList
 * @description Wrapper around Vuetify `VList` with integrated `VListItemGroup`.
 * Passes all `VList` props through.
 *
 * @slot default - List items before the group (e.g. subheaders).
 * @slot content - List items inside the `VListItemGroup`.
 */
export default {
  name: 'WorkList',
  props: {
    ...VList.options.props
  },
  components: {
    VList,
    VListItemGroup
  },
};
</script>
<style lang="scss" scoped>
.w-list .v-list-item__icon {
  margin-right: 1rem;
  display: flex;
  align-items: center;
}
</style>
